const CARD_TITLE_FALLBACK = 'Customize Your Bundle';
const CARD_TITLE_TEXT = (document.currentScript && document.currentScript.dataset.cardTitle) || CARD_TITLE_FALLBACK;

const PLAN_CONTAINER = '[class*="cartInfo_card_body_actions_"]';
const ONE_TIME = '__sng_one_time__';
const SUBSCRIBE = '__sng_subscribe__';
const INTERVAL_LABEL = 'Select Subscription Frequency';

const setSelectValue = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;

function commit(original, value) {
    setSelectValue.call(original, value);
    original.dispatchEvent(new Event('change', { bubbles: true }));
}

function findOriginal(container) {
    return Array.from(container.querySelectorAll('select')).find((select) => !select.dataset.sngPlan);
}

function createPlanUi(original) {
    const ui = document.createElement('div');

    ui.dataset.sngPlanUi = '';
    ui.className = 'bundle-plan-selector';

    const header = document.createElement('div');
    header.className = 'bundle-plan-selector__header';

    header.innerHTML = `
        <p class="bundle-plan-selector__subtitle">
            Choose how often you’d like your Subscribe & Save products delivered. One-time products will only be included in your first order.
        </p>
    `;

    const oneTime = document.createElement('button');

    oneTime.type = 'button';
    oneTime.className = 'bundle-plan-option';
    oneTime.dataset.planType = ONE_TIME;

    oneTime.innerHTML = `
        <span
            class="bundle-plan-option__radio"
            aria-hidden="true"
        ></span>

        <span class="bundle-plan-option__content">

            <span class="bundle-plan-option__header">

                <span class="bundle-plan-option__title">
                    One-Time Purchase
                </span>

                <span class="bundle-plan-option__discount">
                    Bundle savings only
                </span>

            </span>

            <span class="bundle-plan-option__description">
                Pay once. Nothing scheduled, nothing to manage.
            </span>

            <span class="bundle-plan-option__saving">
                Bundle discount still applies
            </span>

        </span>
    `;

    const subscription = document.createElement('button');

    subscription.type = 'button';
    subscription.className = 'bundle-plan-option';
    subscription.dataset.planType = SUBSCRIBE;

    subscription.innerHTML = `
        <span
            class="bundle-plan-option__radio"
            aria-hidden="true"
        ></span>

        <span class="bundle-plan-option__content">

            <span class="bundle-plan-option__header">

                <span class="bundle-plan-option__title">
                    Subscribe &amp; Save
                </span>

                <span class="bundle-plan-option__discount">
                    Extra 10% off
                </span>

                <span class="bundle-plan-option__badge">
                    BEST VALUE
                </span>

            </span>

            <span class="bundle-plan-option__description">
                Refills arrive on your schedule, always at the lower price.
            </span>

            <span class="bundle-plan-option__saving">
                Saves an extra $9.90 on this bundle
            </span>

            <span class="bundle-plan-option__divider"></span>

            <span class="bundle-plan-option__frequency">

                <span class="bundle-plan-option__frequency-label">
                    Deliver every
                </span>

                <select
                    class="bundle-plan-frequency"
                    data-sng-plan="interval"
                ></select>

            </span>

            <span class="bundle-plan-option__note">
                <span class="bundle-plan-option__check">
                    ✓
                </span>

                Skip, reschedule, or cancel any time — no fees.
            </span>

        </span>
    `;


    const interval = subscription.querySelector(
        '[data-sng-plan="interval"]'
    );

    oneTime.addEventListener('click', () => {

        if (original.value === original.options[0].value) {
            return;
        }

        commit(
            original,
            original.options[0].value
        );
        console.log("one time purchase clicked");

        sweepPlanSelectors();
        sweepTotalDiscount();
    });


    subscription.addEventListener('click', (event) => {

        if (event.target.closest('select')) {
            return;
        }

        const firstSubscriptionPlan = original.options[1];

        if (!firstSubscriptionPlan) {
            return;
        }

        commit(
            original,
            interval.value || firstSubscriptionPlan.value
        );

        console.log("subscription clicked");

        sweepPlanSelectors();
        sweepTotalDiscount();
    });


    interval.addEventListener('change', (event) => {

        event.stopPropagation();

        commit(
            original,
            interval.value
        );

        sweepPlanSelectors();
        sweepTotalDiscount();
    });

    original.addEventListener('change', () => {
        sweepPlanSelectors();
        sweepTotalDiscount();
    });

    ui.append(
        header,
        subscription,
        oneTime
    );

    original.insertAdjacentElement(
        'afterend',
        ui
    );

    return ui;
}

function syncPlanUi(original, ui) {
    const plans = Array.from(original.options).slice(1);

    const oneTime = ui.querySelector(
        '[data-plan-type="__sng_one_time__"]'
    );

    const subscription = ui.querySelector(
        '[data-plan-type="__sng_subscribe__"]'
    );

    const interval = ui.querySelector(
        '[data-sng-plan="interval"]'
    );

    if (!oneTime || !subscription || !interval) return;

    const signature = plans
        .map(plan => `${plan.value}:${plan.textContent}`)
        .join('|');

    if (interval.dataset.sngSignature !== signature) {
        interval.dataset.sngSignature = signature;

        interval.innerHTML = '';

        plans.forEach(plan => {
            const option = document.createElement('option');

            option.value = plan.value;
            option.textContent = plan.textContent.trim();

            interval.appendChild(option);
        });
    }

    const subscribed = original.selectedIndex > 0;

    oneTime.classList.toggle(
        'is-active',
        !subscribed
    );

    subscription.classList.toggle(
        'is-active',
        subscribed
    );

    oneTime
        .querySelector('.bundle-plan-option__radio')
        .setAttribute(
            'aria-checked',
            String(!subscribed)
        );

    subscription
        .querySelector('.bundle-plan-option__radio')
        .setAttribute(
            'aria-checked',
            String(subscribed)
        );

    if (subscribed) {
        interval.value = original.value;
    } else if (plans.length) {
        interval.value = plans[0].value;
    }

    oneTime.disabled = original.disabled;
    subscription.disabled = original.disabled;
    interval.disabled = original.disabled;

    if (original.style.display !== 'none') {
        original.style.display = 'none';
    }
}

function applyDefaultPlan(original) {
    if (original.dataset.sngDefaulted || original.disabled) return;

    original.dataset.sngDefaulted = '0';

    if (original.selectedIndex <= 0) {
        commit(original, original.options[1].value);
    }
}

function sweepPlanSelectors() {
    document.querySelectorAll(PLAN_CONTAINER).forEach((container) => {
        const original = findOriginal(container);
        const existing = container.querySelector('[data-sng-plan-ui]');

        if (!original || original.options.length < 2) {
            if (existing) existing.remove();

            if (original) {
                original.style.display = '';
            }

            return;
        }

        const ui = existing || createPlanUi(original);

        applyDefaultPlan(original);
        syncPlanUi(original, ui);
    });
}

const CARD = '[class*="pMMBundleBuilderPage_container_"] > [class*="cartInfo_card_"]:not([class*="cartInfo_card_mobile_"])';
const CARD_NOTE_TEXT = '100-Day Money Back Guarantee';

function sweepCardTitle() {
    document.querySelectorAll(CARD).forEach((card) => {
        if (card.querySelector('[data-sng-card-title]')) return;

        const title = document.createElement('h1');
        title.dataset.sngCardTitle = '';
        title.className = 'bundle-card-title';
        title.textContent = CARD_TITLE_TEXT;
        card.prepend(title);
    });
}

function sweepCardNote() {
    document.querySelectorAll(CARD).forEach((card) => {
        if (card.querySelector('[data-sng-card-note]')) return;

        const note = document.createElement('p');
        note.dataset.sngCardNote = '';
        note.className = 'bundle-card-note';
        note.textContent = CARD_NOTE_TEXT;
        card.appendChild(note);
    });
}

const TOTAL_ROW = '[class*="cartInfo_card_body_actions_"] .rbr-totalBox__prices__mainContainer';

function parseMoney(el) {
    if (!el) return NaN;
    return parseFloat(el.textContent.replace(/[^0-9.,]/g, '').replace(/,/g, ''));
}

function getBundleSelectedVariants() {
    return Array.from(
        document.querySelectorAll(
            '[class*="variant_container_"]'
        )
    )
        .map((item) => {
            const fiberKey = Object.keys(item).find((key) =>
                key.startsWith('__reactFiber')
            );

            if (!fiberKey) return null;

            const fiber = item[fiberKey];

            return fiber?.return?.memoizedProps?.variantData || null;
        })
        .filter(Boolean);
}

function getCurrentBundleDiscountPercent() {
    const selectedDiscount = document.querySelector(
        '[class*="styles_discountsContainer_"] [class*="styles_selectedOption_"]'
    );

    if (!selectedDiscount) {
        return 0;
    }

    const match = selectedDiscount.textContent.match(
        /(\d+(?:\.\d+)?)\s*%/
    );

    return match ? Number(match[1]) : 0;
}

function getCalculatedBundleSaleTotal() {
    const variants = getBundleSelectedVariants();
    const discountPercent = getCurrentBundleDiscountPercent();

    const oneTimeSelected =
        document
            .querySelector('[data-plan-type="__sng_one_time__"]')
            ?.classList.contains('is-active');

    return variants.reduce((total, variant) => {
        const price = Number(variant.raw_price);

        if (!Number.isFinite(price)) {
            return total;
        }

        let discountedPrice =
            price * (1 - discountPercent / 100);

        const supportsSubscription =
            window.variantSubscriptionSupport?.[variant.id] === true;

        if (!oneTimeSelected && supportsSubscription) {
            discountedPrice *= 0.90;
        }

        return total + discountedPrice;
    }, 0);
}

function sweepTotalDiscount() {
    document.querySelectorAll(TOTAL_ROW).forEach((row) => {
        const label = row.querySelector('.rbr-total-box-text');
        if (!label) return;

        const regular = parseMoney(
            row.querySelector('.rbr-total-box-rawPrice .money')
        );

        const saleElement = row.querySelector('.rbr-total-box-price .money');

        const sale = parseMoney(
            row.querySelector('.rbr-total-box-price .money')
        );

        let adjustedSale = sale;

        const calculatedTotal = getCalculatedBundleSaleTotal();

        if (Number.isFinite(calculatedTotal)) {
            adjustedSale = calculatedTotal;

            saleElement.textContent =
                `$${adjustedSale.toFixed(2)}`;
        }

        const percent =
            regular > 0 && sale >= 0
                ? Math.round((1 - sale / regular) * 100)
                : 0;

        const existing = label.querySelector(
            '[data-sng-total-discount]'
        );

        if (!percent || !isFinite(percent)) {
            if (existing) existing.remove();
            return;
        }

        const badge = existing || document.createElement('span');

        if (!existing) {
            badge.dataset.sngTotalDiscount = '';
            badge.className = 'bundle-total-discount';
            label.appendChild(badge);
        }

        const text = `${percent}% off`;

        if (badge.textContent !== text) {
            badge.textContent = text;
        }
    });
}

const DISCOUNTS_CONTAINER = '[class*="styles_discountsContainer_"]';

function createDiscountProgress(original) {
    if (original.querySelector('[data-sng-discount-progress]')) {
        return original.querySelector('[data-sng-discount-progress]');
    }

    const ui = document.createElement('div');
    ui.dataset.sngDiscountProgress = '';
    ui.className = 'bundle-discount-progress';

    ui.innerHTML = `
        <div class="bundle-discount-progress__header">
            <div class="bundle-discount-progress__title">
                <span class="bundle-discount-progress__title-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M5 12.5L9.5 17L19 7"
                            stroke="currentColor"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </span>

                <span data-sng-discount-title>
                    Bundle Savings Unlocked!
                </span>
            </div>

            <div
                class="bundle-discount-progress__message"
                data-sng-discount-message
            ></div>
        </div>

        <div class="bundle-discount-progress__track">
            <div
                class="bundle-discount-progress__line"
                data-sng-discount-line
            ></div>

            <div
                class="bundle-discount-progress__steps"
                data-sng-discount-steps
            ></div>
        </div>
    `;

    original.insertAdjacentElement('afterend', ui);

    return ui;
}

function getDiscountOptions(container) {
    return Array.from(
        container.querySelectorAll('[class*="styles_discountOption_"]')
    ).map((option) => {
        const countElement = option.querySelector(
            '[class*="styles_optionCount_"]'
        );

        const countText = countElement
    ? Array.from(countElement.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent.trim())
        .join('')
    : '';

        const discountElements = option.querySelectorAll(
            '[class*="styles_optionCount_"]'
        );

        const discountText = discountElements.length > 1
            ? discountElements[1].textContent.trim()
            : '';

        const check = option.querySelector(
            '[class*="styles_checkContainer_"]'
        );

        const isChecked =
            check &&
            getComputedStyle(check).display !== 'none';

        const itemNumber = parseInt(countText, 10);

        return {
            element: option,
            count: countText,
            itemNumber: Number.isFinite(itemNumber) ? itemNumber : null,
            discount: discountText,
            isChecked
        };
    });
}

function syncDiscountProgress(original, ui) {
    const options = getDiscountOptions(original);

    if (!options.length) return;

    const stepsContainer = ui.querySelector(
        '[data-sng-discount-steps]'
    );

    const line = ui.querySelector(
        '[data-sng-discount-line]'
    );

    const title = ui.querySelector(
        '[data-sng-discount-title]'
    );

    const message = ui.querySelector(
        '[data-sng-discount-message]'
    );

    stepsContainer.innerHTML = '';


    let activeIndex = options.findIndex(option => option.isChecked);

if (activeIndex === -1) {
    const addedCount = getBundleItemCount();

    if (addedCount !== null) {
        options.forEach((option, index) => {

            if (
                option.itemNumber !== null &&
                addedCount >= option.itemNumber
            ) {
                activeIndex = index;
            }
        });
    }
}



    options.forEach((option, index) => {
        const step = document.createElement('div');

        step.className = 'bundle-discount-progress__step';

        const visualIndex = activeIndex === -1 ? 0 : activeIndex;

        if (index <= visualIndex) {
    step.classList.add(
        'bundle-discount-progress__step--completed'
    );
}

if (index === visualIndex) {
    step.classList.add(
        'bundle-discount-progress__step--active'
    );
}

        const marker = document.createElement('div');

        marker.className =
            'bundle-discount-progress__marker';

        if (index <= visualIndex) {
            marker.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M5 12.5L9.5 17L19 7"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            `;
        }

        const discount = document.createElement('div');

        discount.className =
            'bundle-discount-progress__discount';

        discount.textContent = option.discount;

        const count = document.createElement('div');

        count.className =
            'bundle-discount-progress__count';

        count.textContent = `${option.count} items`;

        step.append(marker, discount, count);

        stepsContainer.appendChild(step);
    });

   let progress = 0;

if (activeIndex >= 0) {
    const markers = stepsContainer.querySelectorAll(
        '.bundle-discount-progress__marker'
    );

    const track = ui.querySelector(
        '.bundle-discount-progress__track'
    );

    if (markers[activeIndex] && track) {
        const markerRect = markers[activeIndex].getBoundingClientRect();
        const trackRect = track.getBoundingClientRect();

        const markerCenter =
            markerRect.left + markerRect.width / 2;

        progress =
            (markerCenter - trackRect.left) /
            trackRect.width;
    }
}

line.style.width = `${progress * 100}%`;

    const activeOption = options[activeIndex];

    if (!activeOption) return;

    const nextOption = options[activeIndex + 1];

    if (nextOption) {
        title.textContent =
            `${activeOption.discount} Bundle Savings Unlocked!`;

        message.textContent =
            `Add one more item to unlock ${nextOption.discount}.`;

        message.hidden = false;
    } else {
        title.textContent =
            `${activeOption.discount} Bundle Savings Unlocked!`;

        message.hidden = true;
    }
}

function getBundleItemCount() {

    const elements = document.querySelectorAll('body *');

    for (const element of elements) {
        if (element.children.length > 0) continue;

        const text = element.textContent.trim();

        const match = text.match(/^(\d+)\s+Added$/i);

        if (match) {
            return parseInt(match[1], 10);
        }
    }

    return null;
}

function sweepDiscountProgress() {
    document.querySelectorAll(DISCOUNTS_CONTAINER).forEach((original) => {
        let ui = original.nextElementSibling;

        if (!ui || !ui.matches('[data-sng-discount-progress]')) {
            ui = createDiscountProgress(original);
        }

        syncDiscountProgress(original, ui);

        if (original.style.display !== 'none') {
            original.style.display = 'none';
        }
    });
}

function sweep() {
    sweepPlanSelectors();
    sweepCardTitle();
    sweepCardNote();
    sweepDiscountProgress();
}

const OBSERVER_OPTIONS = { childList: true, subtree: true, characterData: true };

let sweepScheduled = false;

const planObs = new MutationObserver(() => {
    if (sweepScheduled) return;
    sweepScheduled = true;

    setTimeout(() => {
        sweepScheduled = false;
        planObs.disconnect();
        sweep();
        planObs.observe(document.body, OBSERVER_OPTIONS);
    }, 0);
});

sweep();
planObs.observe(document.body, OBSERVER_OPTIONS);

let sweepScheduledTwo = false;

function setupAddedItemsObserver() {
    const addedItemsContainer = document.querySelector(
        '[class*="cartInfo_card_added_items_"]'
    );

    if (!addedItemsContainer) {
        return false;
    }

    const planObsTwo = new MutationObserver(() => {

        if (sweepScheduledTwo) return;

        sweepScheduledTwo = true;

        setTimeout(() => {
            sweepScheduledTwo = false;
            sweepTotalDiscount();
        }, 0);
    });

    planObsTwo.observe(addedItemsContainer, {
        childList: true,
        subtree: true,
        characterData: true
    });

    return true;
}

if (!setupAddedItemsObserver()) {
    const initObserver = new MutationObserver(() => {
        if (setupAddedItemsObserver()) {
            initObserver.disconnect();
        }
    });

    initObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}

setupAddedItemsObserver();
